import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { LoadingState, EmptyState } from "../../components/ui";
import { AuthService } from "../../services/authService";

type State = "loading" | "success" | "error" | "invalid";

const VerifyEmailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [state, setState] = useState<State>(token ? "loading" : "invalid");

  useEffect(() => {
    if (!token) return;
    let active = true;
    AuthService.verifyEmail(token).then(({ ok }) => {
      if (active) setState(ok ? "success" : "error");
    });
    return () => {
      active = false;
    };
  }, [token]);

  const shell = (children: React.ReactNode) => (
    <div className="bg-zinc-950 text-white min-h-screen flex items-center justify-center px-6">
      {children}
    </div>
  );

  if (state === "loading")
    return shell(<LoadingState message="Verifying your email..." size="lg" />);

  if (state === "success") {
    return shell(
      <EmptyState
        title="Email verified"
        description="Your email has been verified. You can now sign in."
        size="md"
        action={
          <Link
            to="/login"
            className="px-5 py-2 bg-amber-400 text-zinc-950 text-sm tracking-wide hover:bg-amber-300 transition-all duration-200"
          >
            Sign in
          </Link>
        }
      />
    );
  }

  // "error" or "invalid" — both show same message, error adds resend link
  return shell(
    <EmptyState
      title="Invalid or expired link"
      description={
        state === "invalid"
          ? "This verification link is invalid. Please request a new one."
          : "This verification link has expired or is invalid. Please request a new one."
      }
      size="md"
      action={
        <Link
          to="/resend-verification"
          className="px-5 py-2 bg-amber-400 text-zinc-950 text-sm tracking-wide hover:bg-amber-300 transition-all duration-200"
        >
          Resend verification email
        </Link>
      }
    />
  );
};

export default VerifyEmailPage;
